import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import './AccountInfo.css';
import { AccountStyle } from './AccountStyle';
import mapStateToProps from 'reducers/actions/stateToProps';
import mapDispatchToProps from 'reducers/actions/dispatchProps';
import LoadingOverlay from 'components/common/loadingOverlay';
import { Button, Typography, Dialog, Grid } from '@material-ui/core';
import { withSnackbar } from 'notistack';
import NewContributor from './NewContributor';
import { AccountHandler } from 'chits-data/dist';
import { mapMemberToContributor } from 'components/mapper/objectMapping';
import { AgGridReact } from 'ag-grid-react';
import Constants from 'components/utils/constants';
let console = Constants.consoleWrapper(false);
class SharingManager extends React.Component {

  constructor(props) {
    super(props);
    this._isMounted = false; // prevents -> Warning: Can't perform a React state update on an unmounted component
    this._accountHandler = new AccountHandler();
  }

  state = {
    open: {
      openNewContributor: false,
      contributorDeleteConfirmation: false,
    },
    roles: this.props.roles,
    openOverlay: false,
    selectedAccount: this.props.selectedAccount,
    members: [],
    enableAddContributor: false,
    enableEditContributor: false,
    enableDeleteContributor: false,
    contributorEditMode: false,
    memberRowsSelected: [],
  };

  componentDidMount() {
    //TODO: If this page accessed without account set; redirect to /info
    let ac = this._accountHandler.getActiveAccount();
    // asynchronously load account information to props
    this._accountHandler.getAccountCached(ac).then((account) => {
      if (account){
        this.props.setCurrentAccount(account);
        this.setState({ roles: Constants.extractRolesFromAccount(account) })
        this.handleGetManagers(account);
      }
    });
  }

  handleGetManagers = async () => {
    this.setState({
      openOverlay: true
    })
    let ac = this._accountHandler.getActiveAccount();
    this._accountHandler.getAccountMembers(ac).then((members) => {
      this.setState({
        members,
        openOverlay: false,
        enableAddContributor: this.state.roles.owner || this.state.roles.admin,
        enableDeleteContributor: false,
        enableEditContributor: false,
      })
    })
  }

  handleDeleteContributor = async () => {
    let member = this.state.memberRowsSelected[0];
    this.setState({ openOverlay: true });
    let ac = this._accountHandler.getActiveAccount();
    this._accountHandler.deleteAccountMember(ac, member.uid).then(()=>{
      this.setState({
        openOverlay: false,
      });
      this.handleCloseModal("contributor");
    })
  };

  handleOpenModal = (modal = "contributor-add") => {
    let showModal = this.state.open;
    showModal.contributorDeleteConfirmation = (modal === "contributor-delete");
    showModal.openNewContributor = (modal === "contributor-add" || modal === "contributor-edit");

    this.setState({
      open: showModal,
      contributorEditMode: (modal === "contributor-edit")
    })
  }

  handleCloseModal = (modal = "contributor") => {
    let showModal = this.state.open;
    showModal.contributorDeleteConfirmation = false;
    showModal.openNewContributor = false;
    this.setState({
      open: showModal
    });
    if (modal === "contributor") {
      this.handleGetManagers()
    }
  };

  onSharingSelectionChanged() {
    let selectedRows = this.sharingGridApi.getSelectedRows();
    this.setState({
      memberRowsSelected: selectedRows,
      enableAddContributor: (this.state.roles.owner || this.state.roles.admin),
      enableDeleteContributor: (selectedRows.length === 1 && (this.state.roles.owner || this.state.roles.admin)),
      enableEditContributor: (selectedRows.length === 1 && (this.state.roles.owner || this.state.roles.admin))
    })
  }

  handleOnSharingGridReady = params => {
    this.sharingGridApi = params.api;
    this.sharingGridColumnApi = params.columnApi;
    this.sharingGridApi.sizeColumnsToFit();
  };

  renderContributorModal() {
    let contributor = mapMemberToContributor({});
    if (this.state.contributorEditMode) {
      let member = this.state.memberRowsSelected[0];
      contributor = mapMemberToContributor(member);
    }
    return (
      <NewContributor
        display={this.state.open.openNewContributor}
        account={this.state.selectedAccount}
        onCancel={() => this.handleCloseModal("contributor")}
        onSubmit={() => this.handleCloseModal("contributor")}
        update={this.state.contributorEditMode}
        member={contributor}
      />
    )
  }
  renderSharingActions() {
    return (
      <Grid container style={{ margin: "4px" }}>
        <Grid item md={12} sm={12} xs={12}>
          {this.state.enableAddContributor && <Button disabled={!this.state.enableAddContributor}
            onClick={() => this.handleOpenModal("contributor-add")}
            variant="contained"
            size="medium"
            color="default">
            <i className="pe-7s-share"></i> Share
                      </Button>}
          &nbsp;
          {this.state.enableEditContributor && <Button disabled={!this.state.enableEditContributor}
              onClick={() => this.handleOpenModal("contributor-edit")}
              variant="contained"
              size="medium"
              color="primary">Edit</Button>}
          &nbsp;
          {this.state.enableDeleteContributor && <Button disabled={!this.state.enableDeleteContributor}
              onClick={() => this.handleOpenModal("contributor-delete")}
              variant="contained"
              size="medium"
              color="secondary">Delete</Button>}
          &nbsp;
        </Grid>
      </Grid>
    )
  }

  renderSharingGrid() {
    const { classes } = this.props;
    console.debug('members', this.state.members)
    const agStyles = `ag-theme-balham ${classes.agThemeModified}`;
    let colDefs = [{
        headerName: "Email Address",
        field: "email",
        // minWidth: 180,
        flex: 2
      }, 
      // {
      //   headerName: "User Id",
      //   field: "uid",
      //   width: 180
      // }, 
      {
        headerName: "Role",
        field: "role",
        // minWidth: 90,
        // maxWidth: 120,
        flex: 1,
        cellRenderer: (params) => {
          switch (params.value) {
            case "admin":
              return "Admin"
            case "viewer":
              return "Viewer"
            case "editor":
              return "Editor"
            case "contributor":
              return "Contributor"
            default:
              break;
          }
        }
      }, 
      {
        headerName: "Status",
        field: "status",
        // width: 100,
        // minWidth: 80,
        flex: 1,
        // maxWidth: 120,
        cellRenderer: (params) => {
          return (params.value === "ac" ? "Active" : "Inactive")
        }
      }
    ];
    return (
      <Grid container id='accountinfo-members-grid' 
        
      >
        <Grid item xs={12} lg={12}>
          {this.renderSharingActions()}
          {(this.state.members.length === 0) &&
            <Typography>This account is not shared with anybody yet.</Typography>}
          {(this.state.members.length > 0) && <div className={agStyles}>
            <AgGridReact
              autoSizeStrategy={{ 
                type: 'fitProvidedWidth'
              }}
              gridOptions={{
                defaultColDef: {
                  resizable: false,
                  sortable: false,
                  cellStyle: {
                    'font-size': '16px',
                    'font-weight': '200'
                  },
                },
              }}
              // onRowDragEnter={this.onRowDragEnter}
              // onRowDragEnd={this.onRowDragEnd}
              onGridReady={this.handleOnSharingGridReady}
              // onRowDragLeave={this.onRowDragLeave}
              columnDefs={colDefs}
              rowData={this.state.members}
              // getRowClass={this.handleRowHighlights}
              rowSelection="single"
              onSelectionChanged={this.onSharingSelectionChanged.bind(this)}
              // rowDragManaged={true}
              animateRows
              // pagination={!this.state.gridEditMode}
              // paginationPageSize={25}
              enableCellTextSelection="true"
              ensureDomOrder="true"
            />
          </div>}
        </Grid>
      </Grid>
    )
  }

  render() {
    return (
      <>
        {this.renderSharingGrid()}
        <Dialog
          open={this.state.open.contributorDeleteConfirmation}><Typography>
            {`Are you sure to delete the member?`}
          </Typography><Button
            onClick={() => this.handleDeleteContributor()}
          >Yes</Button><Button onClick={() => this.handleCloseModal("")}>No</Button></Dialog>

        {this.state.open.openNewContributor && this.renderContributorModal()}

        {this.state.openOverlay && <LoadingOverlay />}
      </>
    )
  }
}

SharingManager.propTypes = {
  classes: PropTypes.object.isRequired,
  display: PropTypes.bool.isRequired,
  selectedAccount: PropTypes.object.isRequired,
  roles: PropTypes.object.isRequired
}

export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(withStyles(AccountStyle)(SharingManager)));
